import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventCategory,
  GaTrackingEventName,
  GATrackingEventType,
  GaTrackingStringConstantEnum,
} from '../../constants';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import get from 'lodash.get';
import { GaTrackingHelpersService } from '~shared/modules/ga-tracking/utils/ga-tracking-helpers.service';
import { getBlackWeekPaylodProperties } from '~shared/modules/ga-tracking/utils/ga-tracking-black-week.util';
import { environment } from '~env/environment';

export class GATrackingProductClickEvent implements GATrackingEvent {
  contentNameURL = `${environment.appBaseUrl()}${this.url}`;

  constructor(
    private url: string,
    private product: Product,
    private priceType: PriceTypes,
    private pageName: string,
    private index: number,
    private isBlackDealsEnabled: boolean,
    private searchTerm?: string
  ) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ProductClick;
  }

  getPayload(): GATrackingEventPayload {
    const dimension29 = GaTrackingHelpersService.getReferencePriceTypeFromProduct(this.product);
    const dimension31 = GaTrackingHelpersService.getDimension31FromProduct(this.product);

    const leafCategory = get(this.product, 'categories[0]', '');
    const BRAND_NAME_PATH = 'attributes.brand.name';
    const productTracking = {
      'content-name': this.contentNameURL,
      ecommerce: {
        click: {
          actionField: {
            list: this.pageName,
          },
          products: [
            {
              name: get(this.product, 'name'),
              id: get(this.product, 'id'),
              price:
                this.priceType === PriceTypes.b2b
                  ? get(this.product, 'bestOffer.price.netPrice', 0)
                  : get(this.product, 'bestOffer.price.grossPrice', 0),
              brand: get(this.product, BRAND_NAME_PATH, ''),
              category: leafCategory?.name,
              position: this.index + 1,
              dimension14:
                this.product.bestOffer.volumePrice?.length > 0
                  ? GaTrackingStringConstantEnum.Yes
                  : GaTrackingStringConstantEnum.No,
              dimension12: get(this.product, 'hasPromotion', false),
              dimension32: get(
                this.product,
                'attributes.energyEfficiencyClass',
                GaTrackingStringConstantEnum.NoEECLabel
              ),
              ...(!!dimension29 ? { dimension29 } : {}),
              ...(!!dimension31 ? { dimension31 } : {}),
              ...getBlackWeekPaylodProperties(this.isBlackDealsEnabled, this.product),
              dimension56: this.searchTerm
            },
          ],
        },
      }
    };

    return {
      category: GaTrackingEventCategory.Product,
      event: GaTrackingEventName.ProductClick,
      gtmCustom: productTracking,
    };
  }
}
